module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAABCklEQVR4Xu2asQ3CQAxF/wlEmCA7pIMtaDIAa8AiqWCFNCgtE0SCiZIGo+zwG+teBrDsf9++J+eKKv9K5fULAXBA5QrQApUbgCFIC9AClStQ7pNeIV1K+ObB9TyuXds3Tm1382dthqcxZoRC73Kb9CvyFb8VfT2NS9f2R6cA+/m7HIaHNaYiYnNAOBNNJYAkBMABtAAzgCHILWBWIA0HcA3CAYAQJAgJQoKQICRo5qA8CxFACBAChAAhQAgQAoQAIUDIrAArsSz/BkFhUBgUBoVBYVAYFAaFzSDITjAVCvNMrvaHku7+zxaP1+LZTsydLw5wK5otHg7IdmLufHGAW9Fs8XBAthNz5/sHBLJ7jpsKvvQAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/languageflags/it.png
// module id = 177
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22